import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/associati/AssociatiList.vue'),
		meta: {
			title: 'associates',
			acl: 'section.associati'
		}
	},
	
];

export default routes;